import styled from 'styled-components'

export const Seller = styled.span`
    font-weight: 500;
    font-size: 12px;
    margin-right: 16px;
    color: #696977;
    display: inline-block;
`
